import 'style/style.scss';
import HomePage from 'pages/HomePage';
import {Form} from 'components/Form';

$(document).ready(() => {
    const homePage = new HomePage();

    const form = new Form();
    form.init();
    
});


// WEBPACK FOOTER //
// ./static/js/index.js